export default "__VITE_ASSET__QJ_M5ipc__"